import React, { useEffect, useState } from 'react'
import { Box, Button, Text, Modal } from '@deseretbook/react-ui'
import { MOBILE_APP_LINKS } from '../../utils/constants'

import './MobileDisclaimer.css'

/**
 * Determines whether the current device is a mobile device.
 * This is done by checking the user agent and/or the screen size.
 * @returns {string} The type of device (Mobile, Tablet, or Desktop).
 */
export const getMobileOS = () => {
  // 1. Prefer modern Client Hints (Chrome 89+, Edge 89+, Opera 75+)
  const chPlatform = (navigator.userAgentData && navigator.userAgentData.platform) || ''

  if (/android|tablet/i.test(chPlatform)) return 'Android'
  if (/ios|mac/i.test(chPlatform) && /Mobile/i.test(navigator.userAgent)) {
    // iPad on iPadOS often reports "Mac"; the extra Mobile test catches it.
    return 'iOS'
  }

  // 2. Fall back to the classic user‑agent string
  const ua = navigator.userAgent
  if (/Android|tablet/i.test(ua)) return 'Android'
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'iOS'

  return 'Other'
}

/**
 * MobileDisclaimer component that displays a modal warning users that the application is not optimized for mobile devices.
 * It checks the device type and shows the modal if it's a mobile or tablet device.
 */
const MobileDisclaimer = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [storeUrl, setStoreUrl] = useState(MOBILE_APP_LINKS.Android)

  /**
   * Closes the modal and sets the local storage item to prevent it from showing again.
   */
  const handleModalClose = () => {
    setIsOpen(false)
    localStorage.setItem('showMobileDisclaimer', 'false')
  }

  /**
   * Checks the device type and shows the modal if it's a mobile or tablet device if the user hasn't previously interacted with the modal.
   */
  useEffect(() => {
    const showMobileDisclaimer = localStorage.getItem('showMobileDisclaimer') !== 'false'

    if (showMobileDisclaimer) {
      const os = getMobileOS()
      setStoreUrl(MOBILE_APP_LINKS[os])

      if (os !== 'Other') setIsOpen(true)
    }
  }, [])

  return (
    <Modal id="MobileDisclaimerContainer" isOpen={isOpen} onClose={handleModalClose}>
      <Box className="mobile-disclaimer-body">
        <Text className="mobile-disclaimer-text">
          This application is not optimized for mobile devices.
        </Text>
        <Text className="mobile-disclaimer-text">
          For the best experience, please <b>Download the App</b> or use a desktop or laptop
          computer.
        </Text>
        <Box alignItems="center" justifyContent="space-between" style={{ marginTop: '2rem' }}>
          <Button className="mobile-disclaimer-button" as="a" href={storeUrl}>
            Download the App
          </Button>
          <Button
            className="mobile-disclaimer-button mobile-disclaimer-button-close"
            onClick={handleModalClose}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
export default MobileDisclaimer
